/**
 * Controller for the vd-popover component.
 *
 * @class PopoverController
 */
export default class PopoverController {
  constructor($attrs, $element, vdPopover) {
    'ngInject'
    this._$attrs = $attrs
    this._$element = $element
    this._vdPopover = vdPopover
  }

  $onInit() {
    this.onPopoverRegistered()
  }

  onPopoverRegistered() {
    this.popoverInstance = this._vdPopover._getPopoverInstance(this._$element)
    if (this.popoverInstance && this.popoverInstance.openAsModal) {
      this._$element.addClass('vd-popover-container--modal')
    }
  }

  $postLink() {
    this._$attrs.$addClass('vd-popover-container')
  }
}
